import React from 'react';

import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import Button from '@components/Button';
import Price from '@components/ui/price';
import MilePriceBadge, { MilePriceBadgeVariant } from '@uikit/milePriceBadge';
import { VEHICLE_ONE_WAY_FEE_INFO_TEXT } from '@constants/constants';

import {
  DailyAndTotalPriceWrapper,
  DailyPriceTitleStyled,
  PriceInfoStyled,
  PriceTitleStyled,
  RightColWrapperStyled,
} from '../CarRentalCard.styled';

interface IPriceInfo {
  milePrice: number;
  price: number;
  totalPrice: number;
  oneWayFee: number;
  dayCount: number;
  onCarSelect: () => void;
}

const PriceInfo = ({
  milePrice = 0,
  price = 0,
  totalPrice = 0,
  dayCount = 0,
  oneWayFee = 0,
  onCarSelect,
}: IPriceInfo) => {
  return (
    <RightColWrapperStyled>
      <DailyAndTotalPriceWrapper>
        {price ? (
          <PriceInfoStyled>
            <DailyPriceTitleStyled>Günlük Fiyat</DailyPriceTitleStyled>
            <Price fontSize={21} price={price} />
          </PriceInfoStyled>
        ) : null}

        {oneWayFee ? (
          <PriceInfoStyled>
            <DailyPriceTitleStyled>
              Tek Yön Ücreti{' '}
              <Tooltip title={VEHICLE_ONE_WAY_FEE_INFO_TEXT}>
                <InfoCircleOutlined />
              </Tooltip>
            </DailyPriceTitleStyled>
            <Price fontSize={21} price={oneWayFee} />
          </PriceInfoStyled>
        ) : null}

        {dayCount && totalPrice ? (
          <PriceInfoStyled>
            <PriceTitleStyled>{dayCount} Günlük Fiyat</PriceTitleStyled>
            {milePrice ? (
              <MilePriceBadge
                variant={MilePriceBadgeVariant.SOLID}
                isRounded
                milePrice={milePrice}
              />
            ) : null}
            <Price fontSize={21} price={totalPrice} />
          </PriceInfoStyled>
        ) : null}
      </DailyAndTotalPriceWrapper>
      <Button onClick={onCarSelect} className='carRentalCard__payButton'>
        Hemen Öde
      </Button>
    </RightColWrapperStyled>
  );
};

export default PriceInfo;
